import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";
import { useConsent } from "@/context/ConsentContext";

export const CookieBanner = () => {
  const { open, accept, reject } = useConsent();

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-3 bottom-3 z-[70] mx-auto max-w-3xl rounded-3xl glass-strong p-5 sm:p-6"
          data-testid="cookie-banner"
        >
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <div className="flex items-start gap-3">
              <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-lavender/15 text-lavender-deep">
                <Cookie size={18} />
              </span>
              <p className="text-sm leading-relaxed text-navy-soft">
                Usiamo cookie tecnici e, solo con il tuo consenso, contenuti di terze parti (es. video YouTube).
                Puoi accettarli o rifiutarli. Dettagli nella{" "}
                <Link to="/cookie" className="text-lavender-deep underline underline-offset-2">Cookie Policy</Link>.
              </p>
            </div>
            <div className="flex shrink-0 gap-3">
              <button
                data-testid="cookie-reject"
                onClick={reject}
                className="rounded-full bg-white px-6 py-2.5 text-sm font-medium text-navy border border-navy/15 hover:border-navy/40 transition-colors"
              >
                Rifiuta
              </button>
              <button
                data-testid="cookie-accept"
                onClick={accept}
                className="rounded-full bg-lavender px-6 py-2.5 text-sm font-medium text-white hover:bg-lavender-deep transition-colors"
              >
                Accetta
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
